// @file Shred types for the Wall collections store.

import type { FolderId, UserGroupId } from '@@/types'

// TODO: turn combined_recents and combined_shared to recents and shared when we deprecare old recents and old shared
type CrossLibraryCollectionFilter =
  | 'favorites'
  | 'imports'
  | 'combined_recents'
  | 'combined_shared'
  | 'gallery'
  | 'writable_favorites'
  | 'writable_combined_recents'
  | 'writable_combined_shared'
  | 'search'

type WallsFilter =
  | 'all'
  | 'made'
  | 'liked'
  | 'recents'
  | 'shared'
  | 'contributed'
  | 'network'
  | 'archived'
  | 'trashed'
  | 'writableShared'
  | 'writableLiked'
  | 'writableNetwork'
  | 'writableRecents'
  | 'portfolio'
  | 'private_walls'
  | 'writable_all'
  | 'combined_shared_user'
  | 'combined_shared_library'
  | 'profile'
  | 'templates'
  | 'make'
  | CrossLibraryCollectionFilter

type WallSortAttribute = 'name' | 'date'
type WallSortDirection = 'asc' | 'desc'

interface FolderCollectionKey {
  typeKey: 'folderId'
  indexKey: FolderId
}
interface FilterCollectionKey {
  typeKey: 'filter'
  indexKey: WallsFilter
}

interface SearchCollectionKey {
  typeKey: 'search'
  indexKey: string
}

interface UserGroupFolderCollectionKey {
  typeKey: CollectionKeyTypes.GroupFolderId
  indexKey: UserGroupId
}

type CollectionKey = FolderCollectionKey | FilterCollectionKey | SearchCollectionKey | UserGroupFolderCollectionKey

enum CollectionKeyTypes {
  Filter = 'filter',
  FolderId = 'folderId',
  GroupFolderId = 'groupFolderId',
  Search = 'search',
}

interface CollectionsTree<T> {
  filter: Partial<Record<WallsFilter, T>>
  folderId: Record<FolderId, T>
  groupFolderId: Record<UserGroupId, T>
  search: Record<string, T>
}
type CollectionsSubtree<T> =
  | Partial<Record<WallsFilter, T>>
  | Record<FolderId, T>
  | Record<UserGroupId, T>
  | Record<string, T>
export { CollectionKeyTypes }
export type {
    CrossLibraryCollectionFilter,
    WallsFilter,
    WallSortAttribute,
    WallSortDirection,
    CollectionKey,
    CollectionsTree,
    CollectionsSubtree,
}
